<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-xl-8">
                <div class="card card-body border-0 shadow mb-4">
                    <h2 class="h5 mb-4">Inscrição para o treinamento:</h2>
                    <Inscription/>
                </div>
            </div>
            <div class="col-12 col-xl-4">
                <div class="card shadow border-0 text-center p-0 mb-2">
                    <div class="profile-cover rounded-top"
                         :style="{ 'background-image': 'url(/' + course?.thumbnail + ')' }"></div>
                    <div class="card-body pb-5">
                        <h5 class="fw-normal mb-3" >{{ course?.course_name }}</h5>
                        <p class="text-gray mb-4" style="text-align: justify">
                            {{ course?.course_description }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Inscription from "@/Parcials/Forms/Inscription";
import { useStore } from 'vuex'

export default {
    components: {Inscription},
    props: {
        course: { type: Object, default: () => ({}) },
        course_code: { type: String, default: '' },
        cities: { type: Array, default: () => ([]) },
        editions: { type: Array, default: () => ([]) },
        errors: { type: Object, default: () => ({}) },
    },
    setup(props) {
        const store = useStore();

        store.dispatch('inscription/setCourseCode', props.course_code);
        store.dispatch('inscription/setCities', props.cities);
        store.dispatch('inscription/setEditions', props.editions);
        store.dispatch('inscription/setErrors', props.errors);
    }
}
</script>

<style scoped>

</style>
